import { CurrentSessionResponse } from "../models/api/auth/currentSessionResponse";
import { baseApi } from "./baseApi";

export const sessionApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getCurrentSession: builder.query<CurrentSessionResponse, void>({
            query: () => `${import.meta.env.VITE_HOSTNAME_API}/session/me`,
            providesTags: ["session"],
            keepUnusedDataFor: 300,
        }),
    }),
});

export const { useGetCurrentSessionQuery } = sessionApi;